import { queryOptions, useMutation } from "@tanstack/react-query";
import { DateTime } from "luxon";

import { countryCodeToFlag } from "@/common/utils/unicode";
import {
  CompanySimpleUserToApprovalState,
  getUsers1,
  GetUsers1ApprovalState,
  GetUsers1SortCol,
  setUserState,
} from "@/generated/api/users";

const pendingUsersQuery = ({
  page,
  search,
}: {
  page: string;
  search: string;
}) =>
  queryOptions({
    queryFn: async ({ signal }) => {
      const users = await getUsers1(
        {
          approvalState: GetUsers1ApprovalState.WAITING,
          page,
          search,
          sortCol: GetUsers1SortCol.EMAIL,
        },
        { signal },
      );
      return {
        totalSize: users.totalSize,
        users: users.data.map(
          ({
            createdAt,
            companyName,
            companyNumber,
            companyId,
            approvalState,
            companyCountry,
            userEmail,
            ...user
          }) => ({
            ...user,
            approvalStatus: approvalState,
            company: {
              country: companyCountry ? countryCodeToFlag(companyCountry) : "",
              id: companyId,
              name: companyName,
              number: companyNumber,
            },
            createdAt: DateTime.fromISO(createdAt),
            email: userEmail,
          }),
        ),
      };
    },
    queryKey: ["get-users", search, page],
    staleTime: Infinity,
  });

const useUserStateMutation = () =>
  useMutation({
    mutationFn: ({
      userCompanyRelationId,
      state,
    }: {
      userCompanyRelationId: number;
      state: CompanySimpleUserToApprovalState;
    }) => setUserState(userCompanyRelationId, state),
    mutationKey: ["set-user-state"],
  });

export { pendingUsersQuery, useUserStateMutation };
